module.exports = __webpack_public_path__ + "static/cod-f48436bc4584cb322863b529b919dd50.webp";